import type { VendorPrice } from '../../types/models';

interface VendorRowProps {
  vendor: VendorPrice;
  rank: number;
}

function formatPrice(cents: number, currency: string): string {
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

export function VendorRow({ vendor, rank }: VendorRowProps) {
  return (
    <a
      href={vendor.url}
      target="_blank"
      rel="noopener noreferrer"
      className="card flex items-center justify-between hover:border-lime-500 transition-colors"
    >
      <div className="flex items-center gap-4">
        <div className="text-lime-400 font-mono text-lg w-6">{rank}</div>
        <div>
          <div className="font-semibold text-neutral-100">{vendor.vendor}</div>
          <div className="text-xs text-neutral-400">
            {vendor.inStock ? 'In stock' : 'Out of stock'}
          </div>
        </div>
      </div>
      <div className="text-lg font-semibold text-neutral-100">
        {formatPrice(vendor.priceCents, vendor.currency)}
      </div>
    </a>
  );
}
